import React from 'react';
import { useIntl } from 'react-intl';
import OECheckbox from '../../../../../../../../global/oe-checkbox/oe-checkbox';

const noop = () => undefined;

export const CheckboxValuePicker: React.FC = () => {
    const { formatMessage } = useIntl();

    return (
        <div className='module-attribute__checkbox-options'>
            <OECheckbox
                checked
                isDisabled
                onChange={noop}
                label={formatMessage({
                    id: 'oe.hubModule.checkboxSelected',
                    defaultMessage: 'Selected',
                    description: 'Selected option for checkbox attribute',
                })}
            />
        </div>
    );
};